export default __webpack_public_path__ + "static/media/stars.0e1bd760.svg";